import { useAuth0 } from "@auth0/auth0-react";
import { useQuery } from "@tanstack/react-query";
import api from "@/lib/axios";
import { AUTH0_ROLES_CLAIM } from "@/lib/config";

export type AppRole = "indiqr-admin" | "indiqr-influenciador" | "indiqr-vendedor";

export interface ApiUser {
  id: number;
  email: string;
  roles: string[];
  company_id: number | null;
}

export function useRoles(): AppRole[] {
  const { user } = useAuth0();
  if (!user) return [];
  const roles = (user[AUTH0_ROLES_CLAIM] as string[]) || [];
  return roles.filter((r): r is AppRole =>
    ["indiqr-admin", "indiqr-influenciador", "indiqr-vendedor"].includes(r)
  );
}

export function useCurrentUser() {
  const { isAuthenticated, isLoading: authLoading } = useAuth0();

  const query = useQuery<ApiUser>({
    queryKey: ["user", "me"],
    queryFn: async () => {
      const { data } = await api.get("/user/me");
      return data;
    },
    enabled: isAuthenticated,
  });

  return {
    ...query,
    isAuthLoading: authLoading,
  };
}
